import React, {useEffect, useState} from "react";
import ResultsAreEmptyLabel from "@src/Components/Ui/ResultsAreEmpty";
import {
    IApplication, IApplicationInternal, IApplicationBase,
} from "@src/Components/Pages/Main/Content/ApplicationsPage/Interfaces/interfaces";
import AppsTable
    from "@src/Components/Pages/Main/Content/ApplicationsPage/ApplicationCatalogue/AppListTab/AppsTable/AppsTable";
import FullWidthSearch from "@src/Shared/Components/FullWidthSearch/FullWidthSearch";
import filterByTableColumns from "Tools/filterByTableColumns";

interface IProps {
    externalApps: IApplication[];
    internalApps?: IApplicationInternal[];
    isEnabledApps: boolean;
    editExternalApp: (id: string) => void;
    editInternalApp?: (id: string) => void;
    removeInternalApp?: (id: string) => void;
}

const AppListTab = (props: IProps) => {
    const [allApps, setAllApps] = useState<IApplicationBase[]>([]);
    const [filteredApps, setFilteredApps] = useState<IApplicationBase[]>([]);
    const [searchText, setSearchText] = useState<string>("");

    const formatAppsToAppBase = (apps: any[], isInternal: boolean) => {
        if (!apps) return [];

        return apps.map(app => ({
            clientId: app?.clientId,
            displayName: app?.displayName,
            description: app?.description,
            isInternal
        } as IApplicationBase))
    };

    const getAppBaseList = () => {
        const formattedExternalApps = formatAppsToAppBase(props.externalApps, false);
        const formattedInternalApps = formatAppsToAppBase(props.internalApps, true);

        return formattedExternalApps
            .concat(formattedInternalApps)
            .sort((a, b) => a.displayName.localeCompare(b.displayName))
    }

    const handleFilterChange = (text: string) => {
        const filterResult = filterByTableColumns<IApplicationBase>(allApps, text);

        setFilteredApps(filterResult);
        setSearchText(text);
    };

    useEffect(() => {
        const allApps = getAppBaseList();

        setAllApps(allApps);
        setFilteredApps(allApps);
    }, [props]);

    const onEditButtonClick = (id: string) => {
        const isInternal = filteredApps.find(app => app.clientId === id).isInternal;

        if (isInternal) {
            props.editInternalApp(id);
        } else {
            props.editExternalApp(id);
        }
    }

    return (
        <div>
            <FullWidthSearch
                value={searchText}
                onChange={(text: string) => handleFilterChange(text)}
            />

            {filteredApps.length > 0
                ? <AppsTable
                    apps={filteredApps}
                    isEnabledApps={props.isEnabledApps}
                    onEditButtonClick={(id) => onEditButtonClick(id)}
                    onRemoveButtonClick={(id) => props.removeInternalApp(id)}
                />
                : <ResultsAreEmptyLabel/>
            }
        </div>
    )
}

export default AppListTab;
